import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {ActionFinishedModule} from '@aztrix/components/action-finished';
import {ButtonModule} from '@aztrix/components/button';
import {PropertySelectModule} from '@aztrix/components/property-select';
import {SpinnerModule} from '@aztrix/components/spinner';
import {ValueEditModule} from '@aztrix/components/value-edit';
import {TranslatePipe} from '@aztrix/translate';
import {IconsModule} from '@aztrix/icons';

import {FeedbackFormComponent} from './feedback-form/feedback-form.component';
import {FeedbackSearchComponent} from './feedback-search/feedback-search.component';
import {IconForJiraRequestTypePipe} from './feedback-search/icon-for-jira-request-type.pipe';
import {FeedbackService} from './feedback.service';
import {HelperPipesModule} from '@aztrix/helpers';

@NgModule({
  declarations: [IconForJiraRequestTypePipe, FeedbackSearchComponent, FeedbackFormComponent],
  imports: [
    CommonModule,
    IconsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    ActionFinishedModule,
    PropertySelectModule,
    ValueEditModule,
    SpinnerModule,
    ButtonModule,
    IconsModule,
    HelperPipesModule,
    TranslatePipe,
  ],
  providers: [FeedbackService],
  exports: [FeedbackFormComponent, FeedbackSearchComponent],
})
export class FeedbackModule {}
